import { render, staticRenderFns } from "./OrganizationGetSetup.vue?vue&type=template&id=2adbb76d&scoped=true&"
import script from "./OrganizationGetSetup.vue?vue&type=script&lang=js&"
export * from "./OrganizationGetSetup.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationGetSetup.vue?vue&type=style&index=0&id=2adbb76d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbb76d",
  null
  
)

export default component.exports